import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigHelper } from './helpers/config.helper';
import { ResultWrapper, CountryDto, RegionDto } from '../dtos/dto';

@Injectable({
  providedIn: 'root'
})
export class CountryRegionService {

  constructor(
    private http: HttpClient,
    private configHelper: ConfigHelper
  ) { }

  getCountries(): Observable<ResultWrapper<CountryDto[]>> {
    return this.http.get<ResultWrapper<CountryDto[]>>(this.configHelper.getApiUrl("countries"), {});
  }

  getRegions(countryId: number): Observable<ResultWrapper<RegionDto[]>> {
    return this.http.get<ResultWrapper<RegionDto[]>>(this.configHelper.getApiUrl("country/" + countryId + "/regions"), {});
  }

  getCountriesWithScoreRecipients(testTypeId: number): Observable<ResultWrapper<CountryDto[]>> {
    const params = new HttpParams().set("testTypeId", testTypeId.toString());
    return this.http.get<ResultWrapper<CountryDto[]>>(this.configHelper.getApiUrl("CountriesWithScoreRecipients"), { params });
  }

  getRegionsWithCertainTestType(countryId: number, testTypeId: number): Observable<ResultWrapper<RegionDto[]>> {
    return this.http.get<ResultWrapper<RegionDto[]>>(this.configHelper.getApiUrl("Country/" + countryId + "/" + testTypeId + "/Regions"), {});
  }

  getCountriesWithActiveTestCentres(): Observable<ResultWrapper<CountryDto[]>> {
    return this.http.get<ResultWrapper<CountryDto[]>>(this.configHelper.getApiUrl("CountriesWithActiveTestCentres"), {});
  }

  getTransferRegions(brandTestTypeId: number): Observable<ResultWrapper<RegionDto[]>> {
    return this.http.get<ResultWrapper<RegionDto[]>>(this.configHelper.getApiUrl("Country/" + brandTestTypeId + "/TransferRegions"), {});
  }

  getTransferRegionsByDeliveryMethodId(brandTestTypeId: number, deliveryMethodId: number): Observable<ResultWrapper<RegionDto[]>> {
    return this.http.get<ResultWrapper<RegionDto[]>>(this.configHelper.getApiUrl("Country/" + brandTestTypeId + "/" + deliveryMethodId + "/TransferRegions"), {});
  }

  getShouldUseHCaptcha(): Observable<ResultWrapper<boolean>> {
    return this.http.get<ResultWrapper<boolean>>(this.configHelper.getApiUrl("ShouldUseHCaptcha"), {});
  }

}
